// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"7c84a5fc","428":"134c86e8","677":"eb736098"}[chunkId] + ".chunk.css";
};